import { Component, OnChanges, Input, SimpleChanges, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ReferenceCodeService } from '@app/admin/reference-code/reference-code.service';
import { ApplicationService } from '@app/applications/application.service';
import { LoanApplication, ApplicationAccessSpecifier } from '@app/applications/applications.model';
import { NameValueDto } from '@ig-core/interfaces/name-value-dto';
import { BusinessDocumentComposite, Documents } from './business-document.model';
//validation code
import { ValidationService } from '../../../application-validators/validation.service';
import { IgFileService, Files } from '@ig-core/form/igFile.service';
import { ImagePreviewDialogService } from '@app/utils/image-preview-dialog/image-preview-dialog.service';
import { BusinessEntity } from '@app/leads/leads.model';
import { DateAdapter, MatSnackBar } from '@angular/material';
import { SessionStorageService } from 'angular-web-storage';
import { DateFormatPipe } from '@app/utils/date-format.pipe';
import { File, Folder, FolderFilesComposite } from '@app/applications/application-details/loanInformation/loan-folder-files/loan-folder-files.model';
import * as fileSaver from 'file-saver';
import { FileUploadService } from '@app/utils/file-upload/file-upload.service';
import { ConfirmationDialogService } from '@app/utils/confirmation-dialog/confirmation-dialog.service';
import { SecureStorageService} from '../../../../../../projects/ig-core/src/lib/authentication/secureStorage.service';
@Component({
  selector: 'eng-business-document',
  templateUrl: 'business-document.template.html',
  styleUrls: ['../../application-details.styles.scss']
})
export class BusinessDocumentComponent implements OnInit {

  @Input()
  application: LoanApplication;
  @Input()
  menuCode: string;
  @Input()
  business: BusinessEntity;

  businessDocuments: BusinessDocumentComposite[];
  businessDocumentsForm: FormGroup;
  selectedDocument: BusinessDocumentComposite;
  businessDocumentTypes: NameValueDto[];

  isFormDisabled: boolean;
  showForm: boolean;
  allowAccess: boolean;
  menuItemAllowAccess: boolean;

  allFilesInFolder: FolderFilesComposite;
  applicationAccessSpecifiers: ApplicationAccessSpecifier[];
  menuItemAccessSpecifier: ApplicationAccessSpecifier;

  constructor(private formBuilder: FormBuilder,
    private referenceCodeService: ReferenceCodeService,
    private applicationService: ApplicationService,
    private validationService: ValidationService,
    private fileService: IgFileService,
    private _snackbar: MatSnackBar,
    private secureStorageService: SecureStorageService,
    private customDatepipe: DateFormatPipe,
    private confirmationDialogService: ConfirmationDialogService,
    private imagePreviewDialogService: ImagePreviewDialogService,
    private fileUploadService: FileUploadService) {
    this.businessDocumentsForm = this.formBuilder.group({
      docType: '',
      docName: '',
      verifiedFlag: ''
    });
    this.allowAccess = this.applicationService.allowAccess;
  }

  ngOnInit() {
    this.getRefCodes();
    this.isFormDisabled = true;
    this.applyValidatorsToBusinessDocuments();
    this.getMenuItemAccess();
  }

  getRefCodes() {
    this.referenceCodeService.getShortRefCodes('business_misc_doc').subscribe((response: any) => {
      this.businessDocumentTypes = response.business_misc_doc;
    });
  }

  fetchBusinessdocuments() {
    this.showForm = false;
    this.applicationService.getBusinessDocuments(this.application.uid)
      .subscribe((response: any) => {
        if (response) {
          this.businessDocuments = response.body;
          this.businessDocuments.forEach((element, index) => {
            this.businessDocuments[index].documents["deleteBtnDisabled"] = true;
          });
          this.showForm = (this.businessDocuments && this.businessDocuments.length > 0);
          this.buildBusinessDocumentsForm();
        }
      });
  }

  changeSelectedDocuments(businessDocument?: BusinessDocumentComposite, index?: number, from?: string) {
    if (!businessDocument) {
      businessDocument = new BusinessDocumentComposite();
    }
    this.showForm = true;
    this.businessDocuments.forEach((element, i) => {
      this.businessDocuments[i].documents.deleteBtnDisabled = true;
    });
    if (from != "new") {
      this.businessDocuments[index].documents.deleteBtnDisabled = false;
    }
    this.buildBusinessDocumentsForm(businessDocument);
  }

  buildBusinessDocumentsForm(businessDocuments?: BusinessDocumentComposite) {
    if (this.showForm) {
      if (!businessDocuments) {
        businessDocuments = this.businessDocuments[0];
        this.businessDocuments[0].documents.deleteBtnDisabled = false;
      }
      //   this.businessDocumentsForm = this.formBuilder.group({
      this.businessDocumentsForm.patchValue({
        docType: businessDocuments.documents.documentType != undefined ? businessDocuments.documents.documentType : '',
        docName: businessDocuments.documents.documentName != undefined ? businessDocuments.documents.documentName : '',
        verifiedFlag: businessDocuments.documents.verifiedFlag != undefined ? businessDocuments.documents.verifiedFlag : null
      });
      this.selectedDocument = businessDocuments;
      this.getSelectedFolderFiles(this.selectedDocument.documents.fileFolderUid)
    }
  }

  enableDisableForm() {
    this.isFormDisabled = false;
  }

  cancelForm() {
    this.businessDocuments.forEach((element, i) => {
      this.businessDocuments[i].documents.deleteBtnDisabled = true;
    });
    if (this.businessDocuments && this.businessDocuments.length > 0) {
      this.businessDocuments[0].documents.deleteBtnDisabled = false;
      this.buildBusinessDocumentsForm(this.businessDocuments[0]);
    } else {
      this.showForm = false;
    }
    this.isFormDisabled = true;
  }
  //this function will apply validators to form group
  applyValidatorsToBusinessDocuments() {
    this.validationService.applyValidationRules(this.businessDocumentsForm, "BusinessDocuments").then((controlValidators) => {
      this.fetchBusinessdocuments();
    }).catch(() => {
    })
  }


  //this function open up the image viewer dailog box
  openImagePreviewDialog() {
    this.imagePreviewDialogService.open({ "images": this.allFilesInFolder })
  }

  //this function will get either this menu item  is editable or readonly 
  getMenuItemAccess() {
    this.applicationService.getApplicationAccessModifiers(this.application.uid)
      .subscribe((response) => {
        this.applicationAccessSpecifiers = response.body;
        this.menuItemAccessSpecifier = this.applicationAccessSpecifiers
          .find(accessSpecifier => accessSpecifier.category === this.menuCode);
        if (this.menuItemAccessSpecifier) {
          this.menuItemAllowAccess = this.menuItemAccessSpecifier.allowAccess;
        }
      });
  }

  //this function is called onclick of '+' button,
  //after clicking the new empty form will open to enter details
  addNewDocument() {
    let newDocument = new BusinessDocumentComposite();
    newDocument.documents = new Documents()
    this.buildBusinessDocumentsForm(newDocument);
    this.isFormDisabled = false;
    this.changeSelectedDocuments(newDocument, undefined, "new");
  }

  //this function is called onclick of save button
  saveDocument() {
    //this will mark touched all controls in formgroup
    this.validationService.markFormGroupTouched(this.businessDocumentsForm)
    //check the document form is valid or not,if valid then only save will happen 
    if (this.businessDocumentsForm.valid) {
      let todaydate = new Date();
      let savingDocument = this.selectedDocument.documents
      if (!savingDocument.uid) {
        savingDocument.linkToType = 'entity';
        savingDocument.linkToUid = this.business.uid;
        savingDocument.contextType = 'application';
        savingDocument.contextUid = this.application.uid;
      }

      let kycFormFields = this.businessDocumentsForm.value;
      //savingDocument.verificationDate = this.customDatepipe.transform(todaydate, 'ISODATE');
      savingDocument.documentType = kycFormFields.docType;
      savingDocument.documentName = kycFormFields.docName;
      savingDocument.verifiedFlag = kycFormFields.verifiedFlag;
      this.applicationService.saveBusinessDocuments(this.application.uid,
        this.business.uid, savingDocument).subscribe((response) => {
          this.isFormDisabled = true;
          this._snackbar.open("Document updated successfully", "Close", {
            duration: 2000,
          });
          this.isFormDisabled = true;
          this.fetchBusinessdocuments();
        }, (failure) => {
          let errormesg = []
          errormesg.push("Document update failed")
          errormesg.push(failure)
          this.applicationService.displayErrorMessages(errormesg);
        }
        );
    } else {
      let errormesg = []
      errormesg.push("Form is not valid")
      this.applicationService.displayErrorMessages(errormesg);
    }
  }

  //this function open up the image upload dailog box
  //if file upload should allow single and multiple file upload, we need to pass "uploadType":"multiple"
  openImageFileUploadDialog() {
    if (this.selectedDocument.documents.fileFolderUid) {
      this.fileUploadService.open({ "uploadType": "multiple", "folderUid": this.selectedDocument.documents.fileFolderUid, "applicationUid": this.application.uid, "files": this.allFilesInFolder.fileInfo })
      this.fileUploadService.confirmed().subscribe(data => {
        this.getSelectedFolderFiles(data.folderUid)
      })

    } else {
      this._snackbar.open("Please add a folder to upload files", "Close", {
        duration: 5000,
      });
    }
  }

  getSelectedFolderFiles(folderUid) {
    if (folderUid) {
      this.applicationService.getAllFilesInApplicationFolder(this.application.uid, folderUid).subscribe((response: any) => {
        if (response) {
          this.allFilesInFolder = response.body;
          this.allFilesInFolder.fileInfo.forEach(element => {
            if (element.fileSize) {
              element["convertedFileSize"] = this.applicationService.bytesToSize(element.fileSize)
            }
          });
        }
      });
    }
  }

  //this function will call onclick of download icon in file's section
  downloadFile(file) {
    this.applicationService.downloadFileFromApplicationFolder(this.application.uid, file.folderUid, file.fileId).subscribe(image => {
      const blob = new Blob([image.data], { type: file.type });
      fileSaver.saveAs(blob, file.fileName);
      this._snackbar.open("File has been downloaded successfully", "Close", {
        duration: 5000,
      });
    })
  }

  //this function will be called on click of delete icon on collatral list
  deleteDocument(selectedDocument) {
    this.applicationService.documentDelete(this.application.uid, selectedDocument.documents.uid).subscribe((response) => {
      if(response.body.status == "success") {
      this._snackbar.open("Document deleted successfully", "Close", {
        duration: 2000,
      });
      this.fetchBusinessdocuments();
    } else {
      let errormesg = []
      errormesg.push("Document deleted failed")
      errormesg.push(response.body.status)
      this.applicationService.displayErrorMessages(errormesg);
    }}, (failure) => {
      let errormesg = []
      errormesg.push("Document deleted failed")
      errormesg.push(failure)
      this.applicationService.displayErrorMessages(errormesg);
    });
  }

  openDeleteConfirmation() {
    this.confirmationDialogService.open({ "btnCancelText": "Cancel", "btnConfirmText": "Delete", "message": "Are you sure you want to delete this Document?" })
    this.confirmationDialogService.confirmed().subscribe(data => {
      if (data) {
        this.deleteDocument(this.selectedDocument)
      }
    })
  }

   //this function will be called on click of delete icon on file list
deleteFile(selectedFile){
  this.applicationService.fileDelete(this.application.uid, selectedFile.uid).subscribe((response) => {
    if(response.body.status == "success") {
    this._snackbar.open("File deleted successfully", "Close", {
      duration: 2000,
    });
    this.getSelectedFolderFiles(this.selectedDocument.documents.fileFolderUid);
  } else {
    let errormesg =[]
    errormesg.push("File deleted failed")
    errormesg.push(response.body.message)
    this.applicationService.displayErrorMessages(errormesg);
  }}, (failure) => {
    let errormesg =[]
    errormesg.push("File deleted failed")
    errormesg.push(failure)
    this.applicationService.displayErrorMessages(errormesg);
  });
}

  openfileDeleteConfirmation(selectedFile){
      this.confirmationDialogService.open({ "btnCancelText":"Cancel","btnConfirmText":"Delete","message":"Are you sure you want to delete this File?"})
      this.confirmationDialogService.confirmed().subscribe(data=>{
        if(data){
        this.deleteFile(selectedFile)
        }
      })
    
  }

  viewPdf(file){
    this.fileService.fileStreamById(file.fileId,"false").subscribe(res =>{
      window.open(res.data, '_blank');
    })
  }
}